module.exports = __webpack_public_path__ + "img/ic_edit.d70a1569.svg";